import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestCard', {
    renderErrorTitle: 'Oops, we could not load the request data',
    renderErrorDescription: `
        If you see this message, it means that we've already been notified about this problem.
        But it won't hurt to ping us on <supportLink>support@approvalmax.com</supportLink>`,
});
